/**
 * React DOM compatibility shim for MUI v4.
 *
 * Next.js 16 ships a compiled react-dom based on React 19 which removes
 * the `findDOMNode` export. MUI v4 depends on `findDOMNode` in several
 * components (Table, ButtonBase, etc.).
 *
 * This module re-exports everything from Next.js's compiled react-dom and
 * adds a lightweight `findDOMNode` polyfill so MUI v4 components work.
 */

// Re-export everything from the real (Next.js compiled) react-dom
// eslint-disable-next-line no-restricted-imports
const ReactDOM = require('next/dist/compiled/react-dom');

// Polyfill findDOMNode for MUI v4 compatibility
function findDOMNode(componentOrElement) {
  if (componentOrElement == null) {
    return null;
  }
  // If it's already a DOM node, return it directly
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }
  // For React component instances, access the underlying DOM node
  // via the _reactInternals fiber (React 18+)
  const fiber = componentOrElement._reactInternals || componentOrElement._reactInternalFiber;
  if (fiber) {
    let node = fiber;
    while (node) {
      if (node.stateNode && node.stateNode.nodeType === 1) {
        return node.stateNode;
      }
      node = node.child;
    }
  }
  return null;
}

module.exports = {
  ...ReactDOM,
  findDOMNode,
};
